import * as React from 'react';

function SvgControlUnit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.8 30" {...props}>
      <path
        className="controlUnit_svg__st0"
        d="M3.3 1.1c-1.2 0-2.2 1-2.2 2.2v23.4c0 1.2 1 2.2 2.2 2.2h41.2c1.2 0 2.2-1 2.2-2.2V3.3c0-1.2-1-2.2-2.2-2.2H3.3zm3.8 3.5h33.7c1.2 0 2.2 1 2.2 2.2v5.5c0 1.2-1 2.2-2.2 2.2H7.1c-1.2 0-2.2-1-2.2-2.2V6.9c0-1.3 1-2.3 2.2-2.3zM24 18.7c1.5 0 2.8 1.3 2.8 2.8 0 1.5-1.3 2.8-2.8 2.8s-2.8-1.3-2.8-2.8c0-1.6 1.3-2.8 2.8-2.8zm8.3 0c1.5 0 2.8 1.3 2.8 2.8 0 1.5-1.3 2.8-2.8 2.8s-2.8-1.3-2.8-2.8c0-1.6 1.2-2.8 2.8-2.8zm8.2 0c1.5 0 2.8 1.3 2.8 2.8 0 1.5-1.3 2.8-2.8 2.8s-2.8-1.3-2.8-2.8c0-1.6 1.3-2.8 2.8-2.8zm-28.4.3h7.4l-3.7 5-3.7-5zm-4.6.1l3.7 5H3.8l3.7-5z"
      />
    </svg>
  );
}

export default SvgControlUnit;
